import { render, staticRenderFns } from "./ArhslglSgarhPage.vue?vue&type=template&id=8a708b80&scoped=true&"
import script from "./ArhslglSgarhPage.vue?vue&type=script&lang=js&"
export * from "./ArhslglSgarhPage.vue?vue&type=script&lang=js&"
import style0 from "./ArhslglSgarhPage.vue?vue&type=style&index=0&id=8a708b80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a708b80",
  null
  
)

export default component.exports